import NxWizardPhotoGalleryStep2 from '@/modules/content/wizard/components/WizardPhotoGalleryStep2';
import NxWizardMultipleImagesForm from '@/modules/content/wizard/components/WizardMultipleImagesForm';

/**
 * Config for content wizard.
 * @type {{}}
 */
const config = {
  mainTaxonTypes: [
    'microsite',
    'section',
    'blog',
  ],
  photoGalleryDefaultCreateOption: 'ZIP',
};

/**
 * Customize this function to fill draft of wizard forms from from a wizardContext object
 * @param type
 * @param draft
 * @param wizardContext
 */
const fillDraft = (type, draft, wizardContext) => {
  // console.debug('Customize this function to fill wizard draft form', type, draft, wizardContext);
};

export default {
  config,
  fillDraft,
  NxWizardPhotoGalleryStep2,
  NxWizardMultipleImagesForm,
};
